// import { useTranslation } from '@pancakeswap/localization'
// import { Currency } from '@pancakeswap/sdk'
import { Flex, FlexGap, Box, useMatchBreakpoints } from '@pancakeswap/uikit'
// import replaceBrowserHistory from '@pancakeswap/utils/replaceBrowserHistory'
// import { AppBody } from 'components/App'
import { useRouter } from 'next/router'
import { useCallback, useContext, useEffect, useState } from 'react'
// import { useSwapActionHandlers } from 'state/swap/useSwapActionHandlers'
// import { currencyId } from 'utils/currencyId'

import { useSwapHotTokenDisplay } from 'hooks/useSwapHotTokenDisplay'
// import { useCurrency } from 'hooks/Tokens'
// import { Field } from 'state/swap/actions'
import { useDefaultsFromURLSearch, useSwapState } from 'state/swap/hooks'
import { useSwapActionHandlers } from 'state/swap/useSwapActionHandlers'
import { Currency } from '@pancakeswap/swap-sdk-core'
import replaceBrowserHistory from '@pancakeswap/utils/replaceBrowserHistory'
import { Field } from 'state/swap/actions'
import currencyId from 'utils/currencyId'
import { useCurrency } from 'hooks/Tokens'
import { useExchangeChartManager } from 'state/user/hooks'
import { useGsapEntrance } from 'hooks/useGsapEntrance'
import { useAtomValue } from 'jotai'
import GeckoTerminalChart from 'components/GeckoTerminalChart'
import Page from '../Page'
import { RouteDetailsPanel, routeTradeAtom } from './V3Swap/components/RouteDetailsPanel'
// import HotTokenList from './components/HotTokenList'
// import useWarningImport from './hooks/useWarningImport'
import { V3SwapForm } from './V3Swap'
import { StyledInputCurrencyWrapper, StyledSwapContainer } from './styles'
import { SwapFeaturesContext } from './SwapFeaturesContext'
import useWarningImport from './hooks/useWarningImport'

export default function Swap() {
  const entranceRef = useGsapEntrance<HTMLDivElement>()
  const routeTrade = useAtomValue(routeTradeAtom)
  const { isMobile, isTablet, isDesktop } = useMatchBreakpoints()
  const [userChartPreference, setUserChartPreference] = useExchangeChartManager(isMobile)
  const [isChartDisplayed, setIsChartDisplayed] = useState(userChartPreference)


  const { query } = useRouter()
  // const { isDesktop } = useMatchBreakpoints()
  const {
    isChartExpanded,
    // setIsChartExpanded,
    // isChartSupported,
    // isHotTokenSupported,
  } = useContext(SwapFeaturesContext)
  const [isSwapHotTokenDisplay, setIsSwapHotTokenDisplay] = useSwapHotTokenDisplay()
  // const { t } = useTranslation()
  const [firstTime, setFirstTime] = useState(true)

  useEffect(() => {
    if (firstTime && query.showTradingReward) {
      setFirstTime(false)
      setIsSwapHotTokenDisplay(true)

      if (!isSwapHotTokenDisplay && isChartDisplayed) {
        setIsChartDisplayed((currentIsChartDisplayed) => !currentIsChartDisplayed)
      }
    }
  }, [firstTime, isChartDisplayed, isSwapHotTokenDisplay, query, setIsSwapHotTokenDisplay, setIsChartDisplayed])

  // swap state & price data
  const {
    [Field.INPUT]: { currencyId: inputCurrencyId },
    [Field.OUTPUT]: { currencyId: outputCurrencyId },
  } = useSwapState()
  const inputCurrency = useCurrency(inputCurrencyId)
  const outputCurrency = useCurrency(outputCurrencyId)

  const currencies: { [field in Field]?: Currency } = {
    [Field.INPUT]: inputCurrency ?? undefined,
    [Field.OUTPUT]: outputCurrency ?? undefined,
  }

  // const singleTokenPrice = useSingleTokenSwapInfo(inputCurrencyId, inputCurrency, outputCurrencyId, outputCurrency)
  const warningSwapHandler = useWarningImport()
  useDefaultsFromURLSearch()
  const { onCurrencySelection } = useSwapActionHandlers()

  const handleOutputSelect = useCallback(
    (newCurrencyOutput: Currency) => {
      onCurrencySelection(Field.OUTPUT, newCurrencyOutput)
      warningSwapHandler(newCurrencyOutput)

      const newCurrencyOutputId = currencyId(newCurrencyOutput)
      if (newCurrencyOutputId === inputCurrencyId) {
        replaceBrowserHistory('inputCurrency', outputCurrencyId)
      }
      replaceBrowserHistory('outputCurrency', newCurrencyOutputId)
    },

    [inputCurrencyId, outputCurrencyId, onCurrencySelection, warningSwapHandler],
  )

  return (
    <Page removePadding={isChartExpanded} hideFooterOnDesktop={isChartExpanded}>
      <Flex
        ref={entranceRef}
        width="100%"
        height="100%"
        justifyContent="center"
        alignItems={isDesktop ? 'stretch' : 'center'}
        position="relative"
        flexDirection={isDesktop ? 'row' : 'column'}
        mt={isChartExpanded ? '24px' : null}
        style={{ gap: '24px', maxWidth: '1240px', margin: '0 auto' }}
      >
        {isDesktop && isChartDisplayed && (
          <Flex flex="2 1 0%" minWidth="0" flexDirection="column" data-anim>
            <GeckoTerminalChart inputCurrency={inputCurrency} outputCurrency={outputCurrency} height="100%" />
          </Flex>
        )}
        <Flex flexDirection="column" alignItems="center" flex={isDesktop ? '1 1 0%' : undefined}>
          <StyledSwapContainer data-anim $isChartExpanded={isChartExpanded}>
            <StyledInputCurrencyWrapper mt={isChartExpanded ? '24px' : '0'}>
              <V3SwapForm isChartDisplayed={isChartDisplayed} setIsChartDisplayed={setIsChartDisplayed} />
            </StyledInputCurrencyWrapper>
          </StyledSwapContainer>
        </Flex>
      </Flex>
      <Flex width="100%" justifyContent="center" mb="40px">
        <Box width="100%" maxWidth="1240px" mx="auto">
          <RouteDetailsPanel trade={routeTrade} showPlaceholder />
        </Box>
      </Flex>
    </Page>
  )
}
